import React from 'react'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import HeaderDefault from 'components/common/main-container/default/Header';
import { isHideHeaderDefault } from 'helpers/utils';

export const HeaderCompetition = () => {
    const { mirs_competition } = useUrlFriendlyToParameters()
    let out = null
    switch (mirs_competition) {
        default:
            out = isHideHeaderDefault() ? <></> : <HeaderDefault /> 
    }
    return (<section id="mirs-head-app">{out}</section>) //id="mirs-head-app" used in Info App in order to remove it
};

export default HeaderCompetition